import { Flex } from '@chakra-ui/react';

type FormLayoutProps = {
  children: React.ReactNode;
  size?: 'md' | 'full';
};
const sizes = { md: '860px', full: '100%' };

export const FormLayout = ({ children, size = 'full' }: FormLayoutProps) => {
  return (
    <Flex flexDirection="column" gap={6} maxW={sizes[size]}>
      {children}
    </Flex>
  );
};
